import { _parseMeasurement } from "./parse-measurements";

const EXCLUDE_LIST = [
  'gid://shopify/Product/6925491830867',
  'gid://shopify/Product/6925491798099'
];

export function resolveMeasurements(measurement, selectedSize, product, units) {
  let data = null;
  let title = null;
  let selectedMeasurements = null;
  let formattedData = null;

  if (measurement && measurement.data) {
    formattedData = _parseMeasurement(measurement, units);
    title = measurement.title;
  }

  return { data, formattedData, selectedMeasurements, title };
}
